<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="vistorInfoForm">
        <div class="my-section-box__headline">{{ 'common.value_calculator_visitor_info_title' | cxTranslate }}</div>
        <div class="my-section-box visitorInfo" id="visitorInfo">
          <div class="my-section-box-inner">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="search">{{ 'common.value_calculator_firstName' | cxTranslate }}</label>
                <div class="col-12 px-0">
                  <input type="text" formControlName="firstName" />
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="search">{{ 'common.value_calculator_lastName' | cxTranslate }}</label>
                <div class="col-12 px-0">
                  <input type="text" formControlName="lastName" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="search">{{ 'common.value_calculator_email' | cxTranslate }}</label>
                <div class="col-12 px-0">
                  <input type="text" formControlName="eMail" />
                </div>
              </div>
            </div>
            <div class="endsure-checkbox">
              <input type="checkbox" formControlName="valueDisclaimer" />
              <label for="valueDisclaimer" class="form-check-label">{{ 'common.value_calculator_privacy_accept' |
                cxTranslate }}
                <a class="endaSurePrivacy"
                  (click)="openDataProtectionDialog()">{{"common.value_calculator_privacy_accept_link" |
                cxTranslate}}</a></label>
              </div>
              <div class="endsure-btnblock">
                <button type="submit" id="Vistorinfobtn" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                  (click)="endaSureNxt()" [disabled]="!form.valueDisclaimer.value">{{
                  'common.value_calculator_next_button' | cxTranslate }}
                  <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
                </div>
              </div>
            </div>
          </form>
        }
      </div>
    </div>